import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#ffe1dd",  // FFB9C3 // ffe1dd // efb0a1 // FCF8E8
      contrastText: "#333"
    },
    secondary: {
      main: "#efb0a1",
      contrastText: "#333"
    },
    black: {
      main: "#333",
      contrastText: "#fff"
    },
    otherPink:{
      main: "#ffd3c0",
      contrastText: "#fff"
    },
    otherYellow:{
      main: "#fde986",
      contrastText: "#fff"
    },
    otherGreen:{
      main: "#6cd1ad",
      contrastText: "#fff"
    },
    otherPurple:{
      main: "#cbb5c3",
      contrastText: "#fff"
    },
    otherBlue:{
      main: "#96d4c3",
      contrastText: "#fff"
    },
    otherPink2:{
      main: "#ffa3b8",
      contrastText: "#fff"
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#FFB9C3",
            color: "#fff",
            boxShadow: "none",
          },
          textTransform: "inherit",
          borderRadius: "100px",
          fontSize: "0.9rem",
          boxShadow: "none",
          padding: "8px 24px",
        }
       }
    }
  },
});

export default customTheme;
